import IEnvConfig from "./IEnvConfig";

const LocalEnv: IEnvConfig = {
    baseBackendUrl: 'https://localhost:7204'
};

export default LocalEnv;
